/* Helper Functions */

import { CSSProperties, ElementType, ReactNode } from 'react'
import { Navigate, RouteProps } from 'react-router-dom'
import { MASS_MESSAGE_ADMIN } from '../../utils/adminHelpers'
import { User } from '../../reducers/auth/userReducer'
import type { Colors } from '../../styles/theme'

/* ------------------------------------------------ */
// 👇 Do Not Convert Routes : Does not Need Conversion for DSM 2

/* Annual Tax */
import AnnualTaxPanel from '../../features/Taxes/AnnualTaxes/Overview'
import TaxChecklistDocuments from '../../features/Taxes/AnnualTaxes/TaxChecklist/Documents'
import LifeChanges from '../../features/Taxes/AnnualTaxes/TaxChecklist/Form1040/LifeChanges'
import TaxQuestionnaire1120S from '../../features/Taxes/AnnualTaxes/TaxChecklist/Form1120S'
import AdminTaxChecklist from '../../features/Taxes/AnnualTaxes/TaxChecklist/Admin'
import TaxChecklist from '../../features/Taxes/AnnualTaxes/TaxChecklist/TaxChecklist'
import Form1040Details from '../../features/Taxes/AnnualTaxes/TaxChecklist/Form1040/Details'
import AddMissingQTEPayments from '../../features/Taxes/AnnualTaxes/TaxChecklist/Form1040/AddMissingQTEPayments/AddMissingQTEPayments'
import DeductionsAndCredits from '../../features/Taxes/AnnualTaxes/TaxChecklist/Form1040/DeductionsAndCredits'
import IncomeAndLiabilities from '../../features/Taxes/AnnualTaxes/TaxChecklist/Form1040/IncomeAndLiabilities'
import { TaxChecklistPaths } from '../../features/Taxes/AnnualTaxes/constants'
import ExtensionSurveyFormBusiness from '../../features/Taxes/AnnualTaxes/ExtensionSurvey/Business'
import ExtensionSurveyFormPersonal from '../../features/Taxes/AnnualTaxes/ExtensionSurvey/Personal'
import ExtensionSurveyFormCombined from '../../features/Taxes/AnnualTaxes/ExtensionSurvey/Combined'
import YearEndKickoffSurvey from '../../features/Taxes/AnnualTaxes/TaxSeasonKickoff/YearEndKickoffSurvey'
import RequestExtension from '../../features/Taxes/AnnualTaxes/ExtensionSurvey/RequestExtension'
import Ten99FilingViewAllPanel from '../../features/Taxes/AnnualTaxes/Ten99Filing/Ten99FilingViewAllPanel'
import TSKReminderBanner from '../../features/Taxes/AnnualTaxes/TaxSeasonKickoff/TSKReminderBanner'
import ExtensionSurveyReadOnly from '../../features/Taxes/AnnualTaxes/ExtensionSurvey/ExtensionSurveyReadOnly'
import TaxAdvisoryRequest from '../../features/Taxes/Advisory/TaxConsultationRequest'
import TaxAdvisoryPaymentConfirmation from '../../features/Taxes/Advisory/TaxConsultationPaymentConfirmation'
import TaxOptIn from '../../features/Taxes/AnnualTaxes/TaxOptIn/TaxOptIn'
import DeadlineBanner from '../../features/Taxes/AnnualTaxes/TaxSeasonKickoff/DeadlineBanners'

/* YE Bookkeeping */
import { FinalReviewIntro } from '../../features/Bookkeeping/final-review/final-review-intro'
import { UnclarifiedTransactions } from '../../features/Bookkeeping/review-and-close-books/FollowUpOnTransactions'
import { FollowUpOnStatements } from '../../features/Bookkeeping/review-and-close-books/FollowUpOnStatements'
import { FollowUpOnDocuments } from '../../features/Bookkeeping/review-and-close-books/FollowUpOnDocuments'
import { FinalSignOff } from '../../features/Bookkeeping/final-review/final-sign-off'
import FinalReviewIncome from '../../features/Bookkeeping/final-review/final-review-income'
import FinalReviewExpenses from '../../features/Bookkeeping/final-review/final-review-expenses'
import { EndOfYearReviewContainer } from '../../features/Bookkeeping/end-of-year-review'
import { ReviewAndCloseContainer } from '../../features/Bookkeeping/review-and-close-books'

/* 1099 Filing */
import Ten99FilingAddContractorsPanel from '../../features/Taxes/AnnualTaxes/Ten99Filing/AddContractorsPanel'
import Ten99FilingContractorDetailAnd1099Panel from '../../features/Taxes/AnnualTaxes/Ten99Filing/ContractorDetailAnd1099Panel'
import Ten99FilingVerifyPayerInfoPanel from '../../features/Taxes/AnnualTaxes/Ten99Filing/VerifyPayerInfoPanel'
import Ten99FilingDonePanel from '../../features/Taxes/AnnualTaxes/Ten99Filing/DonePanel'

/**
 * ⚠️ Routes that need to be converted for DSM 2 ⚠️
 */

/* Helper Routes */

/* Sign Up */

/* Accounts */
import FinancesNewAccounts from '../Finances/Accounts/NewAccount'

/* Admin */
import AdminFinancesPanel from '../Admin'
import AdminListAllUsersPanel from '../Admin/PaginatedUsersTable/ListAllUsersPanel'
import AllInternalUsersPanel from '../Admin/AllInternalUsersPanel'
import AdminAllBookkeepingReportsPanel from '../Admin/AllBookkeepingReportsPanel'
import AdminAllocationGuidePanel from '../Admin/AllocationGuidePanel'
import AdminIncompleteBookkeepingReportsPanel from '../Admin/IncompleteBookkeepingReportsPanel'
import AdminUserTransactionsPanel from '../Admin/UserTransactionPanel'
import AdminUserInsightsPanel from '../Admin/UserInsightsPanel'
import TransactionCategoriesPanel from '../../features/Admin/TransactionCategories/TransactionCategoriesPanel'
import AdminTransactionRulesPanel from '../Admin/Autocategorization/TransactionRulesPanel'
import AdminUserRecordPanel from '../Admin/UserRecord'
import AdminUserImportedTransactionsPanel from '../Admin/UserTransactionsPanels/ImportedTransactionsPanel'
import AdminMonthlyBooksPanel from '../Admin/UserTransactionsPanels/MonthlyBooksPanel'
import AllActionItemsPanel from '../../features/Admin/ActionItems/AllActionItemsPanel'
import AdminUserDocumentCategoriesPanel from '../../features/Admin/UserDocumentCategories'
import AdminReconciliationPanel from '../Admin/Reconciliation/Screens/ReconciliationPanel'
import BookkeepingCRM from '../../features/Admin/BookkeepingCRM'
import QAPanel from '../../features/Admin/QA'
import AnnualTaxesPanel from '../../features/Admin/Taxes'
import AboundTaxFilingsTable from '../../features/Admin/Taxes/Abound'
import ZendeskBulkMessagePanel from '../../features/Admin/ZendeskBulkMessages/index'
import AdminUserCallsPanel from '../../features/Checkins/Admin/AdminUserCallsPanel'
import AdminProfile from '../../features/Admin/AdminProfile'
import AnnualTaxFilingUserPanel from '../../features/Admin/Taxes/AnnualTaxFilingUserPanel'
import StateIncomeTaxDetailsPanel from '../../features/Admin/Taxes/IncomeTaxDetails/StateIncomeTaxDetails'
import FederalIncomeTaxDetailsPanel from '../../features/Admin/Taxes/IncomeTaxDetails/FederalIncomeTaxDetails'
import QuarterlyTaxCalculationsPanel from '../../features/Admin/UserTaxCalculations'
import QuarterlyTaxEstimateDetailsPanel from '../../features/Admin/QuarterlyTaxEstimateDetails'
import AnnualTaxDetailsPanel from '../../features/Admin/AnnualTaxDetails'
import Storybook from '../../features/Admin/Storybook'
import EmailUsers from '../../features/Admin/EmailUsers'
import AdminBookkeepingEndOfYearReview from '../../features/Bookkeeping/end-of-year-review/admin'

/* Payroll */
import PayrollSettings from '../../features/Payroll/Settings'
import PayrollEmployees from '../../features/Payroll/Employees'
import Employee from '../../features/Payroll/Employee'
import Contractor from '../../features/Payroll/Contractor'
import RunPayroll from '../../features/Payroll/RunPayroll'
import PayrollHistory from '../../features/Payroll/History'
import Enroll from '../../features/Payroll/Enroll'
import CreateTeamMember from '../../features/Payroll/CreateTeamMember'
import CreateEmployee from '../../features/Payroll/CreateTeamMember/CreateEmployee'
import CreateContractor from '../../features/Payroll/CreateTeamMember/CreateContractor'
import MigratePayroll from '../../features/Payroll/Migrate'
import ProcessMigration from '../../features/Payroll/Migrate/ProcessMigration'
import PayrollHistoryDetails from '../../features/Payroll/History/PayrollHistoryDetails'
import ProcessPayroll from '../../features/Payroll/RunPayroll/EmployeePayroll/ProcessPayroll'
import OffCyclePayroll from '../../features/Payroll/RunPayroll/EmployeePayroll/OffCyclePayroll'
import PayrollDocuments from '../../features/Payroll/PayrollDocuments'
import PayrollOverview from '../../features/Payroll/Enroll/PayrollOverview'
import PayrollCompanySetup from '../../features/Payroll/Enroll/PayrollCompanySetup'
import PayrollEnrollLocations from '../../features/Payroll/Enroll/PayrollEnrollLocations'
import PayrollEnrollEmployee from '../../features/Payroll/Enroll/PayrollEnrollEmployee'
import PayrollEnrollSchedule from '../../features/Payroll/Enroll/PayrollEnrollSchedule'
import PayrollEnrollFederal from '../../features/Payroll/Enroll/PayrollEnrollFederal'
import PayrollEmployeeState from '../../features/Payroll/Enroll/PayrollEmployeeState'
import PayrollEnrollBank from '../../features/Payroll/Enroll/PayrollEmployeeBank'
import PayrollEnrollGustoFlow from '../../features/Payroll/Enroll/PayrollEnrollGustoFlow'
import PayrollEnrollComplete from '../../features/Payroll/Enroll/PayrollEnrollComplete'
import ContractorPayroll from '../../features/Payroll/RunPayroll/ContractorPayroll/ContractorPayroll'
import PayrollHistoryContractorDetails from '../../features/Payroll/History/PayrollContractorHistoryDetails'
import CreateEmployeeJob from '../../features/Payroll/CreateTeamMember/CreateEmployeeJob'
import PayrollEmployeeFederal from '../../features/Payroll/Enroll/PayrollEmployeeFederal'
import PayrollEnrollEmployeeJob from '../../features/Payroll/Enroll/PayrollEnrollEmployeeJob'
import { GEP_ENROLL_PATHS } from '../../features/Payroll/helpers'
import PayrollInterestFlow from '../../features/Payroll/Upsell/InterestFlow/PayrollInterestFlow'
import PayrollUsers from '../../features/Payroll/PayrollUsers'
import PayrollUpsell from '../../features/Payroll/Upsell'

/* Reports */
import GoalSetting from '@/featuresV1/GoalSetting'

/* ------------------------------------------------------------------------- */
/*                          🎨   V2 Imports   🎨                             */
/* ------------------------------------------------------------------------- */

/* Login */
import { Login } from '@/features/login'
import { ResetPassword } from '@/features/login/ResetPassword'
import { ResetPasswordForm } from '@/features/login/ResetPasswordForm'
import { AccountSuspended } from '@/features/accounts'
import { CanceledAccount } from '@/features/accounts/CanceledAccount'

/* Signup */
import { AboutYou } from '@/features/user/signup/about-you'
import { YourPractice } from '@/features/user/signup/your-practice'
import { ChoosePlan } from '@/features/user/signup/choose-plan'
import { Payment } from '@/features/user/signup/payment'
import { PracticePriorities } from '@/features/user/signup/practice-priorities'
import { DisqualifiedSignup } from '@/features/user/signup/disqualified'
import { Consult } from '@/features/user/signup/consult'
import { Success } from '@/features/user/signup/success'
import { SignupWaitlist } from '@/features/user/signup/your-practice/SignupWaitlist'
import { SIGNUP_PATHS } from '@/features/user/signup/helpers'
import { PreviousYearTaxForm } from '@/features/user/signup/previous-tax-year-form'

/* Insights */
import { ProfitAndLossPanel } from '@/features/reports/ProfitAndLossPanel'
import { CatchUpBookkeepingUnpaid } from '@/v2-features/accounts/CatchUpBookkeepingUnpaid'

/* Settings */
import { Settings } from '@/features/user/settings/sections'
import { SelfServeCancellation } from '@/features/user/settings/sections/self-serve-cancellation'

/* Dashboard */
import { Dashboard } from '@/features/user/dashboard'
import { OnboardingDashboard } from '@/features/user/dashboard/onboarding'

/* Onboarding */
import { OnboardingV2 } from '@/features/onboarding'
import { SetupLandingCard } from '@/features/onboarding/setup-landing/SetupLandingCard'
import { SetupBankAccountPreScreenCard } from '@/features/onboarding/connect-stage/SetupBankAccountPreScreenCard'
import { ConnectBusinessAccounts } from '@/features/onboarding/connect-stage/ConnectBusinessAccounts'
import { SetupComplete } from '@/features/onboarding/SetupComplete'
import { BookkeepingFlow } from '@/features/onboarding/aha-moments/bookkeeping'
import { TaxesFlow } from '@/features/onboarding/aha-moments/taxes'

/* Your Practice */
/* Your Practice - Profile */
import { PracticeProfile } from '@/features/user/your-practice/profile'
import { YourBusinessForm } from '@/features/user/your-practice/profile/YourBusinessForm'
import { TaxInformationForm } from '@/features/user/your-practice/profile/TaxInformationForm'
import { PersonalInformationForm } from '@/features/user/your-practice/profile/PersonalInformationForm'

/* Your Practice - Documents */
import { Documents } from '@/features/user/your-practice/documents'

/* V2 PNL Reports */
import { AdminProfitAndLossPanel } from '@/features/reports/Admin/AdminProfitAndLossPanel'
import { AdminGeneralLedgerPanel } from '@/features/reports/Admin/AdminGeneralLedgerPanel'
import { AdminBalanceSheetPanel } from '@/features/reports/Admin/AdminBalanceSheet/AdminBalanceSheetPanel'
import { AdminAutoBalanceSheetPanel } from '@/features/reports/Admin/AdminBalanceSheet/AdminAutoBalanceSheetPanel'
import { AdminGeneralJournalPanel } from '@/features/reports/Admin/AdminGeneralJournalPanel'

/* Allocation Guides */
import { AllocationGuidePanel } from '@/features/allocation-guides'
import { AllocationCreation } from '@/features/allocation-guides/AllocationCreation'
import { SingleAllocationGuidePanel } from '@/features/allocation-guides/SingleAllocationGuidePanel'

/* Transactions */
import { TransactionsPanel } from '@/features/transactions'
import { UserTransactionsByCategory } from '@/features/financial-insights/transactions-panel/UserTransactionsByCategory'

/* Taxes Profile */
import { RecalculationProfileFlow } from '@/features/taxes/taxes-profile/recalculation-form-flow'
import { TaxesProfileFlow } from '@/features/taxes/taxes-profile/form-flow'
import { QuarterlyTaxEstimatesPanel } from '@/features/taxes/quarterly-tax-estimates'

/* Annual Tax */
import { PastReturnsPanel } from '@/features/taxes/annual-taxes/overview/PastReturnsPanel'

/* Quarterly Tax Estimates */
import { EstimateBreakdown } from '@/features/taxes/quarterly-tax-estimates/components/estimate-breakdown/EstimateBreakdown'
import { CalculateLateHarborFlow } from '@/features/taxes/quarterly-tax-estimates/components/calculate-safe-harbor-flow'
import { EstimateBreakdownSample } from '@/features/taxes/quarterly-tax-estimates/components/estimate-breakdown/EstimateBreakdownSample'
import {
  BasicPlanQTEUpsell,
  BasicPlanQTEUpsellBanner,
} from '@/features/taxes/quarterly-tax-estimates/BasicPlanUpsell'

/* Financial Insights */
import { InsightsExpensesPanel } from '@/features/financial-insights/expenses'
import { InsightsIncomePanel } from '@/features/financial-insights/income'
import { InsightsProfitPanel } from '@/features/financial-insights/profit'
import { BookkeepingReportPanel } from '@/features/financial-insights/reports/bookkeeping-reports'
import { EoyAlertBanner } from '@/features/financial-insights/reports/bookkeeping-reports/EoyAlertBanner'
import { YearlyReportsPanel } from '@/features/financial-insights/reports/YearlyReportsPanel'
import { PracticeOverview } from '@/features/financial-insights/practice-insights'
import { ExpensesPanel } from '@/features/financial-insights/expenses-breakdown'
import { BookkeepingReportReroute } from '@/features/financial-insights/reports/BookkeepingReportReroute'

/* Dashboard */
import { HeardCommunityBanner } from '@/features/user/dashboard/HeardCommunityBanner'

/* Financial Advisory */
import { FinancialAdvisoryOverview } from '@/features/financial-advisory'
import { FinancialAdvisoryGoals } from '@/features/financial-advisory/panels/GoalsPanel'
import { FinancialAdvisoryInbox } from '@/features/financial-advisory/panels/InboxPanel'

/* Other */
import ZendeskSso from '@/features/zendesk/ZendeskSso'
import {
  MaintenanceBanner,
  MaintenanceBannerWithBorder,
} from '@/components/platform-banners/MaintenanceBanner'
import { ProductFeatureId } from '@/actions/permissionActions'
import { UpgradeToPremiumModal } from '@/components/UpgradeToPremium/UpgradeToPremiumModal'
import { ConditionalReferralsRoute } from '@/v2-components/Routes/conditionalRoutes'
import { RedirectToExternal } from '@/v2-components/Routes/RedirectToExternal'
import { NotFound } from '@/v2-components/Routes/NotFound'

/* ------------------------------------------------------------------------- */
/*                          🙏   Routes Below   🙏                            */
/* ------------------------------------------------------------------------- */

export type RouteConfig = {
  [key: string]: Omit<RouteProps, 'element' | 'path' | 'index' | 'lazy'> & {
    component: ElementType
    customAuth?: (user: User) => boolean
    banner?: ElementType | ElementType[]
    backgroundColor?: keyof typeof Colors
    innerContentWrapperStyle?: CSSProperties
    contentWrapperStyle?: CSSProperties
    /** Restricts access to the route based on the user's permissions
     * @param features - The features that the user must have access to in order to access the route
     * @param includeChildRoutes - If true, the permissions will be checked for all child routes (routes that start with the same path)
     * e.g. setting to true for /taxes/annual would block any route that starts with /taxes/annual/
     */
    requiredPermissions?: {
      features: ProductFeatureId[]
      includeChildRoutes?: boolean
      customPermissionComponent?: ReactNode
    }
  }
}

export const EXTERNAL_ADMIN_ROUTES: RouteConfig = {
  '/admin/finances/list-users': {
    component: AdminListAllUsersPanel,
  },
  '/admin/profile': {
    component: AdminProfile,
  },
  '/admin/finances': {
    component: AdminFinancesPanel,
  },
  '/admin/finances/annual-tax-filings': {
    component: AnnualTaxesPanel,
    backgroundColor: 'white',
  },
  '/admin/finances/annual-tax-filings/:filingId': {
    component: AnnualTaxFilingUserPanel,
  },
  '/admin/finances/transactions/:userId': {
    component: AdminUserTransactionsPanel,
  },
  '/admin/finances/records/:userId/monthly-books/:reportId': {
    component: AdminMonthlyBooksPanel,
  },
  '/admin/finances/financial-reports/:userId/profit-loss': {
    component: AdminProfitAndLossPanel,
  },
  '/admin/finances/financial-reports/:userId/general-ledger': {
    component: AdminGeneralLedgerPanel,
  },
  '/admin/finances/financial-reports/:userId/general-journal': {
    component: AdminGeneralJournalPanel,
  },
  '/admin/finances/financial-reports/:userId/balance-sheet': {
    component: AdminBalanceSheetPanel,
  },
  '/admin/finances/financial-reports/:userId/auto-balance-sheet': {
    component: AdminAutoBalanceSheetPanel,
  },
  '/admin/finances/transactions/:userId/imported': {
    component: AdminUserImportedTransactionsPanel,
  },
  '/admin/finances/records/:userId': {
    component: AdminUserRecordPanel,
  },
  '/admin/finances/records/:userId/calls': {
    component: AdminUserCallsPanel,
  },
  '/admin/finances/records/:userId/allocation-guides/:allocationGuideId': {
    component: AdminAllocationGuidePanel,
  },
  '/admin/finances/records/:userId/submissions/:year': {
    component: AdminBookkeepingEndOfYearReview,
  },
}

export const ADMIN_ROUTES: RouteConfig = {
  '/admin/finances/all-internal-users': {
    component: AllInternalUsersPanel,
  },
  '/admin/finances/mass-messaging': {
    customAuth: (user: User) => MASS_MESSAGE_ADMIN(user),
    component: ZendeskBulkMessagePanel,
  },
  'admin/finances/email-users': {
    component: EmailUsers,
  },
  '/admin/finances/books/crm': {
    component: BookkeepingCRM,
  },
  '/admin/finances/books': {
    component: AdminAllBookkeepingReportsPanel,
  },
  '/admin/finances/books/incomplete': {
    component: AdminIncompleteBookkeepingReportsPanel,
  },
  '/admin/finances/transaction-categories': {
    component: TransactionCategoriesPanel,
  },
  '/admin/finances/transaction-rules': {
    component: AdminTransactionRulesPanel,
  },

  '/admin/finances/insights/:userId': {
    component: AdminUserInsightsPanel,
  },
  '/admin/finances/all-action-items': {
    component: AllActionItemsPanel,
  },
  '/admin/finances/user-document-categories': {
    component: AdminUserDocumentCategoriesPanel,
  },
  '/admin/finances/quarterly-tax-estimate-details': {
    component: QuarterlyTaxEstimateDetailsPanel,
  },
  '/admin/finances/annual-tax-details': {
    component: AnnualTaxDetailsPanel,
  },

  '/admin/finances/abound-tax-filings': {
    component: AboundTaxFilingsTable,
  },
  '/admin/finances/qte-calculations': {
    component: QuarterlyTaxCalculationsPanel,
  },
  '/admin/finances/federal-income-tax': {
    component: FederalIncomeTaxDetailsPanel,
  },
  '/admin/finances/state-income-tax': {
    component: StateIncomeTaxDetailsPanel,
  },
  '/admin/finances/tax-checklist': {
    component: AdminTaxChecklist,
  },
  '/admin/finances/records/:userId/monthly-books/:reportId/reconciliation/:reconciliationId':
    {
      component: AdminReconciliationPanel,
    },
  '/admin/storybook': {
    component: Storybook,
  },
  '/admin/finances/qa': {
    component: QAPanel,
  },
  '/admin/payroll/users': {
    component: PayrollUsers,
  },
}

export const PRIVATE_ROUTES: RouteConfig = {
  '/': {
    component: Dashboard,
    banner: [MaintenanceBanner, TSKReminderBanner, DeadlineBanner],
    backgroundColor: 'white',
  },
  '/dashboard': {
    component: Dashboard,
    banner: [
      MaintenanceBanner,
      HeardCommunityBanner,
      TSKReminderBanner,
      DeadlineBanner,
    ],
    backgroundColor: 'white',
  },
  '/onboarding-dashboard': {
    component: OnboardingDashboard,
    banner: [MaintenanceBannerWithBorder, TSKReminderBanner, DeadlineBanner],
    backgroundColor: 'white',
    innerContentWrapperStyle: {
      padding: 0,
    },
  },
  '/onboarding': {
    component: OnboardingV2,
    backgroundColor: 'white',
  },
  '/onboarding-v2': {
    component: OnboardingV2,
    backgroundColor: 'white',
  },
  '/onboarding-v2/complete': {
    component: SetupComplete,
    backgroundColor: 'white',
  },
  '/onboarding-v2/learning/bookkeeping': {
    component: BookkeepingFlow,
    backgroundColor: 'white',
  },
  '/onboarding-v2/learning/taxes': {
    component: TaxesFlow,
    backgroundColor: 'white',
  },
  '/onboarding-v2/estimate-breakdown-sample': {
    component: EstimateBreakdownSample,
    backgroundColor: 'white',
  },
  '/onboarding/setup/landing': {
    component: SetupLandingCard,
    backgroundColor: 'white',
  },
  '/onboarding/setup/prescreen': {
    component: SetupBankAccountPreScreenCard,
    backgroundColor: 'white',
  },
  '/onboarding/setup/connect-bank': {
    component: ConnectBusinessAccounts,
    backgroundColor: 'white',
  },

  // Settings
  '/accounts': {
    component: Settings,
  },
  /* Unclear if we need this */
  '/accounts/new': {
    component: FinancesNewAccounts,
  },
  /* Unclear if we need this */
  '/accounts/new/oauth': {
    component: FinancesNewAccounts,
  },
  '/accounts/verify/:token': {
    component: Settings,
  },
  '/accounts/choose-plan': {
    component: () => <Payment isUpsell />,
  },
  '/accounts/suspended': {
    component: AccountSuspended,
  },
  '/accounts/canceled': {
    component: CanceledAccount,
  },
  '/accounts/zendesk/sso': {
    component: ZendeskSso,
    backgroundColor: 'white',
  },

  '/transactions': {
    component: TransactionsPanel,
    backgroundColor: 'white',
  },
  '/transactions/:type': {
    component: TransactionsPanel,
    backgroundColor: 'white',
  },
  '/transactions/expenses/:transactionCategoryId': {
    component: UserTransactionsByCategory,
  },
  '/taxes/annual/complete-year-end-bookkeeping': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/intro': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/review-disconnected-accounts':
    {
      component: EndOfYearReviewContainer,
      backgroundColor: 'white',
    },
  '/taxes/annual/complete-year-end-bookkeeping/:year/upload-missing-bank-statements':
    {
      component: EndOfYearReviewContainer,
      backgroundColor: 'white',
    },
  '/taxes/annual/complete-year-end-bookkeeping/:year/categorize-transactions': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/other-income': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/other-expenses': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/business-income-in-personal':
    {
      component: EndOfYearReviewContainer,
      backgroundColor: 'white',
    },
  '/taxes/annual/complete-year-end-bookkeeping/:year/business-expenses-in-personal':
    {
      component: EndOfYearReviewContainer,
      backgroundColor: 'white',
    },
  '/taxes/annual/complete-year-end-bookkeeping/:year/review-owners-investments':
    {
      component: EndOfYearReviewContainer,
      backgroundColor: 'white',
    },
  '/taxes/annual/complete-year-end-bookkeeping/:year/review-owners-distributions':
    {
      component: EndOfYearReviewContainer,
      backgroundColor: 'white',
    },
  '/taxes/annual/complete-year-end-bookkeeping/:year/upload-documents-intro': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/payroll': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/contractor-payments': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/processing-fees': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/first-submission': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/all-done': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/review-income': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/review-expenses': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/fixed-asset-depreciation':
    {
      component: EndOfYearReviewContainer,
      backgroundColor: 'white',
    },
  '/taxes/annual/complete-year-end-bookkeeping/:year/previous-tax-return': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/complete-year-end-bookkeeping/:year/review-document-uploads': {
    component: EndOfYearReviewContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/review-and-close-books/:year/follow-up': {
    component: ReviewAndCloseContainer,
    backgroundColor: 'white',
  },
  '/taxes/annual/review-and-close-books/:year/final-review-intro': {
    component: FinalReviewIntro,
    backgroundColor: 'white',
  },
  '/taxes/annual/review-and-close-books/:year/final-review-income': {
    component: FinalReviewIncome,
    backgroundColor: 'white',
  },
  '/taxes/annual/review-and-close-books/:year/final-review-expenses': {
    component: FinalReviewExpenses,
    backgroundColor: 'white',
  },
  '/taxes/annual/review-and-close-books/:year/final-sign-off': {
    component: FinalSignOff,
    backgroundColor: 'white',
  },
  '/taxes/annual/review-and-close-books/:year/follow-up-transactions': {
    component: UnclarifiedTransactions,
    backgroundColor: 'white',
  },
  '/taxes/annual/review-and-close-books/:year/follow-up-statements': {
    component: FollowUpOnStatements,
    backgroundColor: 'white',
  },
  '/taxes/annual/review-and-close-books/:year/follow-up-documents': {
    component: FollowUpOnDocuments,
    backgroundColor: 'white',
  },
  '/reports/bookkeeping/:reportName': {
    component: BookkeepingReportPanel,
    banner: EoyAlertBanner,
    backgroundColor: 'white',
  },
  '/reports/bookkeeping/:bookkeepingReportMonth/:bookkeepingReportYear/:reportName':
    {
      component: BookkeepingReportPanel,
      banner: EoyAlertBanner,
      backgroundColor: 'white',
    },
  '/reports/bookkeeping/:bookkeepingReportId/:reportName': {
    component: BookkeepingReportReroute,
    backgroundColor: 'white',
  },
  '/reports/yearly': {
    component: YearlyReportsPanel,
    backgroundColor: 'white',
  },
  '/reports/profit-loss': {
    component: ProfitAndLossPanel,
    backgroundColor: 'white',
  },
  '/trends/expenses': {
    component: ExpensesPanel,
    backgroundColor: 'white',
  },
  '/insights/overview': {
    component: PracticeOverview,
    backgroundColor: 'white',
  },
  '/insights/expenses': {
    component: InsightsExpensesPanel,
    backgroundColor: 'white',
  },
  '/insights/income': {
    component: InsightsIncomePanel,
    backgroundColor: 'white',
  },
  '/insights/profit': {
    component: InsightsProfitPanel,
    backgroundColor: 'white',
  },
  '/taxes/annual': {
    component: AnnualTaxPanel,
    backgroundColor: 'white',
    requiredPermissions: {
      features: [ProductFeatureId.annualTaxes],
      includeChildRoutes: true,
      customPermissionComponent: (
        <UpgradeToPremiumModal feature="annual-taxes" />
      ),
    },
  },
  '/taxes/archive': {
    component: PastReturnsPanel,
    backgroundColor: 'white',
  },

  '/taxes': {
    component: () => <Navigate replace to="/taxes/annual" />,
  },
  '/taxes/quarterly': {
    component: QuarterlyTaxEstimatesPanel,
    banner: [BasicPlanQTEUpsellBanner],
    backgroundColor: 'white',
    requiredPermissions: {
      features: [ProductFeatureId.quarterlyTaxes],
      includeChildRoutes: true,
      customPermissionComponent: <BasicPlanQTEUpsell />,
    },
  },
  '/taxes/annual/kickoff-survey': {
    component: YearEndKickoffSurvey,
    backgroundColor: 'white',
  },
  '/taxes/annual/file_1099_nec/verify_business': {
    component: Ten99FilingVerifyPayerInfoPanel,
    backgroundColor: 'white',
  },
  '/taxes/annual/file_1099_nec/contractors': {
    component: Ten99FilingAddContractorsPanel,
    backgroundColor: 'white',
  },
  '/taxes/annual/file_1099_nec/contractors/:contractorUUID': {
    component: Ten99FilingContractorDetailAnd1099Panel,
    backgroundColor: 'white',
  },
  '/taxes/annual/file_1099_nec/done': {
    component: Ten99FilingDonePanel,
    backgroundColor: 'white',
  },
  '/taxes/annual/file_1099_nec/view_all': {
    component: Ten99FilingViewAllPanel,
    backgroundColor: 'white',
  },
  '/taxes/annual/file_1099_nec/contractors/:contractorUUID/edit': {
    component: Ten99FilingContractorDetailAnd1099Panel,
    backgroundColor: 'white',
  },
  '/taxes/annual/file_1099_nec/contractors/:contractorUUID/correction': {
    component: Ten99FilingContractorDetailAnd1099Panel,
    backgroundColor: 'white',
  },
  '/taxes/annual/tax_checklist/': {
    component: TaxChecklist,
    backgroundColor: 'white',
  },
  [`/taxes/annual/tax_checklist/:formId/${TaxChecklistPaths.addMissingQtePayments}`]:
    {
      component: AddMissingQTEPayments,
      backgroundColor: 'white',
    },
  [`/taxes/annual/tax_checklist/:formId/${TaxChecklistPaths.lifeChanges}`]: {
    component: LifeChanges,
    backgroundColor: 'white',
  },
  [`/taxes/annual/tax_checklist/:formId/${TaxChecklistPaths.deductionsAndCredits}`]:
    {
      component: DeductionsAndCredits,
      backgroundColor: 'white',
    },
  [`/taxes/annual/tax_checklist/:formId/${TaxChecklistPaths.incomeAndLiabilities}`]:
    {
      component: IncomeAndLiabilities,
      backgroundColor: 'white',
    },
  [`/taxes/annual/tax_checklist/:formId/${TaxChecklistPaths.checkYourDetails}`]:
    {
      component: TaxQuestionnaire1120S,
      backgroundColor: 'white',
    },
  [`/taxes/annual/tax_checklist/:formId/${TaxChecklistPaths.checkYourDetailsPersonal}`]:
    {
      component: Form1040Details,
      backgroundColor: 'white',
    },
  [`/taxes/annual/tax_checklist/:formId/${TaxChecklistPaths.documents}`]: {
    component: TaxChecklistDocuments,
    backgroundColor: 'white',
  },
  '/taxes/annual/tax_consultations': {
    component: TaxAdvisoryRequest,
    backgroundColor: 'white',
  },
  '/taxes/annual/tax_consultations/:taxConsultationRequestId/confirmed': {
    component: TaxAdvisoryPaymentConfirmation,
    backgroundColor: 'white',
  },
  '/taxes/annual/extension_request': {
    component: RequestExtension,
    backgroundColor: 'white',
  },
  '/taxes/annual/extension_request/business': {
    component: ExtensionSurveyFormBusiness,
    backgroundColor: 'white',
  },
  '/taxes/annual/extension_request/personal': {
    component: ExtensionSurveyFormPersonal,
    backgroundColor: 'white',
  },
  '/taxes/annual/extension_request/combined': {
    component: ExtensionSurveyFormCombined,
    backgroundColor: 'white',
  },
  '/taxes/annual/extension_request/complete/:taxYear': {
    component: ExtensionSurveyReadOnly,
    backgroundColor: 'white',
  },
  '/taxes/annual/opt-in': {
    component: TaxOptIn,
    backgroundColor: 'white',
  },
  '/taxes/quarterly/recalculate': {
    component: RecalculationProfileFlow,
    backgroundColor: 'white',
  },
  '/taxes/quarterly/calculate-safe-harbor': {
    component: CalculateLateHarborFlow,
    backgroundColor: 'white',
  },
  '/taxes/quarterly/:taxYear': {
    component: QuarterlyTaxEstimatesPanel,
  },
  '/taxes/quarterly/:taxQuarter/estimate-breakdown': {
    component: EstimateBreakdown,
    backgroundColor: 'white',
  },
  '/taxes/quarterly/:taxYear/:taxQuarter': {
    component: QuarterlyTaxEstimatesPanel,
  },

  /** PRACTICE - PROFILE **/
  '/practice/profile': {
    component: PracticeProfile,
    backgroundColor: 'white',
  },
  '/practice/profile/editBusiness': {
    component: YourBusinessForm,
    backgroundColor: 'white',
  },
  // Backwards compat link
  '/practice/profile/:profileId/edit': {
    component: () => <Navigate replace to="/practice/profile/editBusiness" />,
  },
  // Backwards compat link
  '/practice/profile/edit': {
    component: YourBusinessForm,
    backgroundColor: 'white',
  },
  '/practice/profile/editTax': {
    component: TaxInformationForm,
    backgroundColor: 'white',
  },
  '/practice/profile/editPersonal': {
    component: PersonalInformationForm,
    backgroundColor: 'white',
  },

  /** PRACTICE - DOCUMENTS **/
  '/practice/documents': {
    component: Documents,
    backgroundColor: 'white',
  },
  '/practice/documents/:tabName/:action': {
    component: Documents,
    backgroundColor: 'white',
  },

  '/messages': {
    component: () => (
      <RedirectToExternal
        to={`https://${process.env.VITE_ZENDESK_SUBDOMAIN}.zendesk.com/hc/en-us/requests?utf8=%E2%9C%93&query=&status=answered`}
      />
    ),
  },
  '/conversations': {
    component: () => (
      <RedirectToExternal
        to={`https://${process.env.VITE_ZENDESK_SUBDOMAIN}.zendesk.com/hc/en-us/requests?utf8=%E2%9C%93&query=&status=answered`}
      />
    ),
    backgroundColor: 'white',
  },
  '/conversations/:id': {
    component: () => (
      <RedirectToExternal
        to={`https://${process.env.VITE_ZENDESK_SUBDOMAIN}.zendesk.com/hc/en-us/requests?utf8=%E2%9C%93&query=&status=answered`}
      />
    ),
    backgroundColor: 'white',
    innerContentWrapperStyle: {
      padding: 0,
    },
  },
  '/allocation-guides': {
    component: AllocationGuidePanel,
    backgroundColor: 'white',
  },
  '/allocation-guides/view/:allocationGuideId': {
    component: SingleAllocationGuidePanel,
    backgroundColor: 'white',
  },
  '/allocation-guides/:state': {
    component: AllocationCreation,
    backgroundColor: 'white',
  },
  '/taxes/profile': {
    component: TaxesProfileFlow,
  },
  '/user-cancellation': {
    component: SelfServeCancellation,
    backgroundColor: 'white',
  },
  '/rewards': {
    component: ConditionalReferralsRoute,
  },
  '/payroll/interest': {
    component: PayrollInterestFlow,
    backgroundColor: 'white',
  },
  '/payroll/welcome': {
    component: PayrollUpsell,
    backgroundColor: 'white',
  },
  '/advisory/overview': {
    component: FinancialAdvisoryOverview,
    backgroundColor: 'white',
  },
  '/advisory/enroll': {
    component: FinancialAdvisoryOverview,
    backgroundColor: 'white',
  },
  '/advisory/goals': {
    component: FinancialAdvisoryGoals,
    backgroundColor: 'white',
  },
  '/advisory/messages': {
    component: FinancialAdvisoryInbox,
    backgroundColor: 'white',
  },
  '/accounts/suspended/catch-up-bookkeeping': {
    component: CatchUpBookkeepingUnpaid,
    backgroundColor: 'white',
  },
  '/goal-setting': {
    component: GoalSetting,
    backgroundColor: 'white',
  },
  '*': {
    component: NotFound,
  },
}

export const PAYROLL_ROUTES: RouteConfig = {
  [GEP_ENROLL_PATHS.intro]: {
    component: Enroll,
    backgroundColor: 'white',
  },
  [GEP_ENROLL_PATHS.overview]: {
    component: PayrollOverview,
  },
  [GEP_ENROLL_PATHS.company]: {
    component: PayrollCompanySetup,
  },
  [GEP_ENROLL_PATHS.federal]: {
    component: PayrollEnrollFederal,
  },
  [GEP_ENROLL_PATHS.locations]: {
    component: PayrollEnrollLocations,
  },
  [GEP_ENROLL_PATHS.employee]: {
    component: PayrollEnrollEmployee,
  },
  [GEP_ENROLL_PATHS.employeeJob]: {
    component: PayrollEnrollEmployeeJob,
  },
  [GEP_ENROLL_PATHS.employeeFederal]: {
    component: PayrollEmployeeFederal,
  },
  [GEP_ENROLL_PATHS.employeeState]: {
    component: PayrollEmployeeState,
  },
  [GEP_ENROLL_PATHS.employeeState]: {
    component: PayrollEmployeeState,
  },
  [GEP_ENROLL_PATHS.employeeBank]: {
    component: PayrollEnrollBank,
  },
  [GEP_ENROLL_PATHS.schedule]: {
    component: PayrollEnrollSchedule,
  },
  [GEP_ENROLL_PATHS.flow]: {
    component: PayrollEnrollGustoFlow,
  },
  [GEP_ENROLL_PATHS.complete]: {
    component: PayrollEnrollComplete,
  },
  '/payroll/migrate': {
    component: MigratePayroll,
    backgroundColor: 'white',
  },
  '/payroll/process_migration': {
    component: ProcessMigration,
  },
  '/payroll/settings': {
    component: PayrollSettings,
  },
  '/payroll/employees': {
    component: PayrollEmployees,
  },
  '/payroll/employee/:uuid': {
    component: Employee,
  },
  '/payroll/create_team_member': {
    component: CreateTeamMember,
  },
  '/payroll/create_employee': {
    component: CreateEmployee,
  },
  '/payroll/create_employee/job/:uuid': {
    component: CreateEmployeeJob,
  },
  '/payroll/create_contractor': {
    component: CreateContractor,
  },
  '/payroll/contractor/:uuid': {
    component: Contractor,
  },
  '/payroll/run_payroll': {
    component: RunPayroll,
  },
  '/payroll/run_payroll/process/:uuid': {
    component: ProcessPayroll,
  },
  '/payroll/run_contractor_payroll': {
    component: ContractorPayroll,
  },
  '/payroll/create_off_cycle_payroll': {
    component: OffCyclePayroll,
  },
  '/payroll/history': {
    component: PayrollHistory,
  },
  '/payroll/history/:uuid': {
    component: PayrollHistoryDetails,
  },
  '/payroll/contractor_history/:uuid': {
    component: PayrollHistoryContractorDetails,
  },
  '/payroll/documents': {
    component: PayrollDocuments,
  },
}

export const PUBLIC_ROUTES: RouteConfig = {
  '/recover': {
    component: ResetPassword,
  },
  '/reset/:token': {
    component: ResetPasswordForm,
  },
  '/login': {
    component: Login,
  },
  '/zendesk/sso': {
    component: Login,
  },
  [SIGNUP_PATHS.referred]: {
    component: AboutYou,
  },
  // STEP 1
  // Title:  About You
  // Path:  /signup
  // Component: AboutYou
  [SIGNUP_PATHS.aboutYou]: {
    component: AboutYou,
  },
  // STEP 2
  // Title:  Your Practice
  // Path:  /signup/about-your-practice
  // Component: AboutYourPractice
  [SIGNUP_PATHS.aboutYourPractice]: {
    component: YourPractice,
  },
  // STEP 3
  // Title:  Choose Plan
  // Path:  /signup/practice-journey -- path here should be named /choose-plan - confusign
  // Component: ChoosePlan
  // TODO: will update paths to match step in upcoming rework
  [SIGNUP_PATHS.practiceJourney]: {
    component: ChoosePlan,
  },
  // STEP 4
  // Title:  Payment
  // Path:  /signup/choose-plan  -- path here is the name of the previous step, this is confusing, should be /payment
  // Component: Payment
  // TODO: will update paths to match step in upcoming rework
  [SIGNUP_PATHS.choosePlan]: {
    component: Payment,
  },
  [SIGNUP_PATHS.practicePriorities]: {
    component: PracticePriorities,
  },
  [SIGNUP_PATHS.disqualified]: {
    component: DisqualifiedSignup,
  },
  [SIGNUP_PATHS.waitlist]: {
    component: SignupWaitlist,
  },
  [SIGNUP_PATHS.consult]: {
    component: Consult,
  },
  [SIGNUP_PATHS.previousYearTax]: {
    component: PreviousYearTaxForm,
  },
  [SIGNUP_PATHS.success]: {
    component: Success,
  },
}

export const ALL_ROUTES = {
  ...EXTERNAL_ADMIN_ROUTES,
  ...ADMIN_ROUTES,
  ...PAYROLL_ROUTES,
  ...PUBLIC_ROUTES,
  ...PRIVATE_ROUTES,
}

export const ROUTES_MAP = {
  EXTERNAL_ADMIN_ROUTES,
  ADMIN_ROUTES,
  PAYROLL_ROUTES,
  PUBLIC_ROUTES,
  PRIVATE_ROUTES,
}
